<template>
  <TabbedPortletOpportunity>
    <TabbedPortletHead v-if="hasMultiplePricing">
      <li class="nav-item">
        <a
          href=""
          class="nav-link"
          :class="{ 'active': selectedTab === tabs.YOUR_PRICING_TAB }"
          @click.prevent="selectTab(tabs.YOUR_PRICING_TAB)">TTC Net Pricing</a>
      </li>
      <li class="nav-item">
        <a
          href=""
          class="nav-link"
          :class="{ 'active': selectedTab === tabs.AGENT_PRICING_TAB }"
          @click.prevent="selectTab(tabs.AGENT_PRICING_TAB)">Consumer Pricing</a>
      </li>
    </TabbedPortletHead>
    <TabbedPortletBody>
      <div class="tab-content">
        <TabbedPortletBodyTab :show="selectedTab === tabs.YOUR_PRICING_TAB">
          <ImageTranslator
            v-model="entryHtml"
            class="mx-4 mb-4"
            @input="updatePricingText"
          />
          <div class="fullEditor">
            <Editor
              v-model="$v[validationGroupName].sections.pricing.$model"
              @blur="$v[validationGroupName].sections.pricing.$touch()"
              :validator="$v[validationGroupName].sections.pricing"
              :showDebugger="false"
              :disabled="isCompletedQuote && !enabled" />
          </div>
        </TabbedPortletBodyTab>
        <TabbedPortletBodyTab :show="selectedTab === tabs.AGENT_PRICING_TAB">
          <div class="fullEditor">
            <Editor
              v-model="$v[validationGroupName].sections.agentPricing.$model"
              @blur="$v[validationGroupName].sections.agentPricing.$touch()"
              :validator="$v[validationGroupName].sections.agentPricing"
              :showDebugger="false"
              :disabled="isCompletedQuote && !enabled" />
          </div>
        </TabbedPortletBodyTab>
      </div>
    </TabbedPortletBody>
  </TabbedPortletOpportunity>
</template>

<script>
import Editor from '@/components/_shared/Editor.vue'
import TabbedPortletOpportunity from "@/components/_shared/tabbed-portlet-opportunity/TabbedPortletOpportunity.vue";
import TabbedPortletHead from "@/components/_shared/tabbed-portlet/TabbedPortletHead.vue";
import TabbedPortletBody from "@/components/_shared/tabbed-portlet/TabbedPortletBody.vue";
import TabYourDetails from "@/components/opportunity-edit/tab-consumer-section/TabYourDetails.vue";
import TabbedPortletBodyTab from "@/components/_shared/tabbed-portlet/TabbedPortletBodyTab.vue";
import {mapGetters} from "vuex";
import {OPPORTUNITY__BRANDS} from "@/constants";
import ImageTranslator from "@/components/opportunity-edit/ImageTranslator.vue";

export default {
  name: 'TabPricing',
  inject: ['$v'],
  components: {
    ImageTranslator,
    TabbedPortletBodyTab,
    TabYourDetails,
    TabbedPortletBody, TabbedPortletHead, TabbedPortletOpportunity, Editor },
  props: {
    validationGroupName: {
      type: String,
      required: true
    },
    isCompletedQuote: {
      type: Boolean,
      required: false
    }
  },
  data() {
    const YOUR_PRICING_TAB = 'your-pricing-tab'
    const AGENT_PRICING_TAB = 'agent-pricing-tab'

    return {
      enabled: true,
      entryHtml: '',
      selectedTab: YOUR_PRICING_TAB,
      tabs: {
        YOUR_PRICING_TAB,
        AGENT_PRICING_TAB,
      }
    };
  },
  watch: {
    opportunityData: {
      immediate: true,
      handler() {
        this.entryHtml = this.$v[this.validationGroupName].sections.pricing.$model;
      }
    },
    selectedTab: {
      immediate: true,
      handler(newValue) {
        this.enabled =
          !this.isCompletedQuote ||
          (this.isTrafalgarRiver && newValue === this.tabs.AGENT_PRICING_TAB);
        this.$emit('onSaveEnabled', this.enabled)
      }
    },
  },
  computed: {
    ...mapGetters({
      'opportunityData': 'opportunity/opportunity',
    }),
    isTrafalgarRiver() {
      return (
        this.opportunityData &&
        [OPPORTUNITY__BRANDS.TRAFALGAR_RIVER].includes(this.opportunityData.properties_opportunity.id_brand)
      );
    },
    hasMultiplePricing() {
      return (
        this.opportunityData &&
        [OPPORTUNITY__BRANDS.TRAFALGAR, OPPORTUNITY__BRANDS.TRAFALGAR_RIVER].includes(this.opportunityData.properties_opportunity.id_brand)
      );
    },
  },
  methods: {
    updatePricingText () {
      const temp = document.createElement('div');
      temp.innerHTML = this.$v[this.validationGroupName].sections.pricing.$model;

      const tables = [...temp.querySelectorAll('.table')];

      temp.querySelectorAll(':scope > p').forEach(p => {
        p.remove();
      });

      tables.slice(1, -3).forEach(table => {
        table.remove();
      });

      const firstTable = temp.querySelector('.table');
      if (firstTable) {
        const type = this.opportunityData.properties_opportunity.id_opportunity_export_type;
        if (type === 33) {
          console.log(this.entryHtml);
          this.entryHtml = this.entryHtml
            .replace("Group Rates & Cabin Allocation", "Group Rates & Cabin Availability");
        }

        this.entryHtml = this.entryHtml
          .replace("Cabin Allocation", "Number of Cabin")
          .replace("Double Occupancy Rate", "Double Per Person")
          .replace("Single Occupancy Rate", "Single Per Person");

        firstTable.insertAdjacentHTML('afterend', this.entryHtml);
      }

      this.$v[this.validationGroupName].sections.pricing.$model = temp.innerHTML;
    },
    selectTab (tabName) {
      this.selectedTab = tabName
    },
  },
}
</script>
